import { render, staticRenderFns } from "./ElectricityData.vue?vue&type=template&id=36f4b6f2&scoped=true"
import script from "./ElectricityData.vue?vue&type=script&lang=js"
export * from "./ElectricityData.vue?vue&type=script&lang=js"
import style0 from "./ElectricityData.vue?vue&type=style&index=0&id=36f4b6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f4b6f2",
  null
  
)

export default component.exports